import {AnnouncementItems} from '../consts/types';
import welcomeEng from './lottieContent/mailbox2510/welcomeEng.svg';
import welcomeHeb from './lottieContent/mailbox2510/welcomeHeb.svg';
import likeAProEng from './lottieContent/mailbox2510/likeAProEng.svg';
import likeAProHeb from './lottieContent/mailbox2510/likeAProHeb.svg';
import writingCoachEng from './lottieContent/mailbox2510/writingCoachEng.json';
import writingCoachHeb from './lottieContent/mailbox2510/writingCoachHeb.json';
import flowEng from './lottieContent/mailbox2510/flowEng.json';
import flowHeb from './lottieContent/mailbox2510/flowHeb.json';
import texts from '../../Form/components/SidePanelForms/texts';
import {getLang} from '../../../Localization';

export const mailbox2510: () => AnnouncementItems[] = () => {
    return [
        {
            type: 'Welcome',
            title: texts.step1_title,
            content: texts.step1_content,
            additionalContent: getLang() === '1' ? welcomeHeb : welcomeEng
        },
        {
            type: 'Content',
            title: texts.step2_title,
            content: texts.step2_content,
            lottieContent: getLang() === '1' ? writingCoachHeb : writingCoachEng
        },
        {
            type: 'Content',
            title: texts.step3_title,
            content: texts.step3_content,
            additionalContent: getLang() === '1' ? likeAProHeb : likeAProEng
        },
        {
            type: 'Content',
            title: texts.step4_title,
            content: texts.step4_content,
            lottieContent: getLang() === '1' ? flowHeb : flowEng
        }
    ];
};
